import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceTask {
    lookupService = new APIServiceLookUp();

    async setTask(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}task/setTask`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllTask(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}task/getAllTask`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}